var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 30.898438 177.40625 L 30.898438 59.855469 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 182.984375 168.546875 L 182.984375 190.558594 C 182.984375 199.171875 175.984375 206.171875 167.371094 206.171875 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 30.898438 45.609375 L 30.898438 10.527344 C 30.898438 6.890625 33.851562 3.9375 37.488281 3.9375 L 176.421875 3.9375 C 180.03125 3.9375 182.984375 6.890625 182.984375 10.527344 L 182.984375 154.300781 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 98.738281 57.941406 L 115.171875 57.941406 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 86.40625 57.941406 L 82.277344 57.941406 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 127.503906 57.941406 L 131.605469 57.941406 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 76.125 45.609375 L 79.433594 25.757812 C 79.898438 22.96875 82.277344 20.945312 85.09375 20.945312 L 128.789062 20.945312 C 131.605469 20.945312 134.011719 22.96875 134.476562 25.757812 L 137.785156 45.609375 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 69.945312 70.273438 L 69.945312 49.710938 C 69.945312 47.441406 71.804688 45.609375 74.074219 45.609375 L 139.835938 45.609375 C 142.105469 45.609375 143.9375 47.441406 143.9375 49.710938 L 143.9375 70.273438 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 148.039062 70.273438 L 112.957031 70.273438 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 98.738281 70.273438 L 65.84375 70.273438 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 86.40625 82.605469 L 78.175781 82.605469 C 75.90625 82.605469 74.074219 80.746094 74.074219 78.476562 L 74.074219 70.273438 L 90.507812 70.273438 L 90.507812 78.476562 C 90.507812 80.746094 88.675781 82.605469 86.40625 82.605469 Z M 86.40625 82.605469 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 127.503906 82.605469 L 135.707031 82.605469 C 137.976562 82.605469 139.835938 80.746094 139.835938 78.476562 L 139.835938 70.273438 L 123.375 70.273438 L 123.375 78.476562 C 123.375 80.746094 125.234375 82.605469 127.503906 82.605469 Z M 127.503906 82.605469 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 68.714844 111.535156 L 99.96875 111.535156 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 74.484375 123.867188 L 68.714844 123.867188 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 99.96875 123.867188 L 87.636719 123.867188 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 50.230469 123.867188 C 53.621094 123.867188 56.382812 121.105469 56.382812 117.714844 C 56.382812 114.296875 53.621094 111.535156 50.230469 111.535156 C 46.8125 111.535156 44.050781 114.296875 44.050781 117.714844 C 44.050781 121.105469 46.8125 123.867188 50.230469 123.867188 Z M 50.230469 123.867188 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 68.714844 140.300781 L 99.96875 140.300781 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 74.484375 152.632812 L 68.714844 152.632812 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 99.96875 152.632812 L 87.636719 152.632812 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 50.230469 152.632812 C 53.621094 152.632812 56.382812 149.871094 56.382812 146.480469 C 56.382812 143.0625 53.621094 140.300781 50.230469 140.300781 C 46.8125 140.300781 44.050781 143.0625 44.050781 146.480469 C 44.050781 149.871094 46.8125 152.632812 50.230469 152.632812 Z M 50.230469 152.632812 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 27.617188 206.171875 C 19.003906 206.171875 12.003906 199.171875 12.003906 190.558594 L 12.003906 181.507812 C 12.003906 179.238281 13.835938 177.40625 16.105469 177.40625 L 147.628906 177.40625 C 149.898438 177.40625 151.757812 179.238281 151.757812 181.507812 L 151.757812 190.558594 C 151.757812 199.171875 158.730469 206.171875 167.371094 206.171875 Z M 27.617188 206.171875 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 154.957031 158.128906 L 142.898438 164.144531 C 141.75 164.71875 140.382812 164.71875 139.234375 164.144531 L 127.175781 158.128906 C 118.042969 153.5625 112.300781 144.238281 112.300781 134.039062 L 112.300781 112.492188 C 112.300781 109.539062 114.242188 106.96875 117.058594 106.148438 L 139.015625 99.886719 C 140.355469 99.503906 141.75 99.503906 143.089844 99.886719 L 165.074219 106.148438 C 167.890625 106.96875 169.832031 109.539062 169.832031 112.492188 L 169.832031 134.039062 C 169.832031 144.238281 164.0625 153.5625 154.957031 158.128906 Z M 154.957031 158.128906 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 137.019531 131.113281 L 133.984375 128.078125 C 131.578125 125.671875 127.667969 125.671875 125.261719 128.078125 C 122.855469 130.484375 122.855469 134.394531 125.261719 136.800781 L 132.644531 144.183594 C 135.050781 146.589844 138.960938 146.589844 141.367188 144.183594 L 156.84375 128.707031 C 159.25 126.300781 159.25 122.390625 156.84375 119.984375 C 154.4375 117.578125 150.527344 117.578125 148.121094 119.984375 Z M 137.019531 131.113281 ",
    transform: "matrix(0.142857,0,0,0.142857,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadron);
export default __webpack_public_path__ + "static/media/padron.b7be61e1.svg";
export { ForwardRef as ReactComponent };